// extracted by mini-css-extract-plugin
export default {"inputPopup":"TextAreaComponent_inputPopup__x3vaW","chat":"TextAreaComponent_chat__MSf50"};